import React, { useEffect, useState } from 'react'
import Icon from 'meinian-package/src/component/icon'
import Button from 'meinian-package/src/baseComponent/button'
import globalData from 'meinian-package/src/common/globalData'
import { WORKBENCH_FORCE_GUIDE_STEP_KEY } from '../forceGuideConfig'
import styles from './index.module.less'

type TForceGuidePanel={
  onClose?: ()=>void,
  positions: Array<DOMRect>
}

export default ({ onClose, positions }:TForceGuidePanel) => {
  const [step, setStep] = useState(null)

  useEffect(() => {
    globalData.get(WORKBENCH_FORCE_GUIDE_STEP_KEY, setStep, 1)
  }, [])

  const onStep = (val) => {
    setStep(val)
    globalData.set(WORKBENCH_FORCE_GUIDE_STEP_KEY, val)
  }

  return <div className={styles.workbenchForceGuideWrap}>
    <div className={styles.workbenchForceGuideMark} />
    {
      step === 1 && <StartModal onClose={onClose} onNext={() => onStep(2)} />
    }
    {
      step === 2 && <Step2 position={positions[0]} onClose={onClose} onNext={() => onStep(3)} />
    }
    {
      step === 3 && <Step3 position={positions[1]} onClose={onClose} onNext={() => onStep(4)} />
    }
    {
      step === 4 && <EndModal onClose={onClose} />
    }
  </div>
}

const StartModal = ({ onClose, onNext }) => {
  return <div className={styles['mn-css-modal']}>
    <div className={styles['mn-css-header']}>
      <Icon type="m-guanbi" className={styles['mn-css-modal-close']} onClick={onClose} />
    </div>
    <div className={styles.startModalContent}>
      欢迎使用美念，两步快速了解一下美念？
    </div>
    <div className={styles.startModalFooter}>
      <div className="cursor-pointer" onClick={() => window.open('/meinian/document')}>详细教程</div>
      <div className="df-center">
        <Button style={{ width: '80px', marginRight: '8px' }} onClick={onClose}>跳过</Button>
        <Button type="primary" style={{ width: '160px' }} onClick={onNext}>开始</Button>
      </div>
    </div>
  </div>
}

const Step2 = ({ onClose, onNext, position }) => {
  return <div className={styles.workbenchForceGuideStep2Wrap}>
    <div
      className={styles.tipDom}
      style={{
        left: position.left,
        top: position.top,
        width: position.width,
        height: position.height
      }}
    >
      <img className={styles.tipDomImageTop} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/workbenchForceGuideStep2Top.png" />
      <img className={styles.tipDomImageBottom} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/workbenchForceGuideStep2Bottom.png" />
    </div>
    <div className={styles.tip}>
      <div className={styles.forceGuidePanelClose} onClick={onClose}>
        <Icon type="m-guanbi" />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>工作台：</div>
        <div className={styles.text}>常用功能、灵感集和采集的内容</div>
        <div className={styles.title} style={{ marginTop: '24px' }}>灵感集：</div>
        <div className={styles.text}>类似文件夹，采集的内容都存在灵感集里</div>
        <div className={styles.title} style={{ marginTop: '24px' }}>款式图库：</div>
        <div className={styles.text}>查看所有已采集的内容</div>
        <div className={styles.title} style={{ marginTop: '24px' }}>智能选款：</div>
        <div className={styles.text}>根据个人采集偏好推荐内容</div>
        <div className={styles.title} style={{ marginTop: '24px' }}>快速访问：</div>
        <div className={styles.text}>在灵感集里可以将灵感集添加到此处快速访问</div>
        <div className={styles.footer}>
          <span style={{ marginRight: '16px' }}>(1/2)</span>
          <Button onClick={onNext}>下一步</Button>
        </div>
      </div>
    </div>
  </div>
}

const Step3 = ({ position, onClose, onNext }) => {
  let src = null

  if (position.width <= 414) { // 1366
    src = 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/workbenchForceGuideStep3_1366.png'
  } else if (position.width <= 471) { // 1440
    src = 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/workbenchForceGuideStep3_1440.png'
  } else if (position.width <= 712) { // 1680
    src = 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/workbenchForceGuideStep3_1680.png'
  } else { // 1920
    src = 'https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/workbenchForceGuideStep3_1920.png'
  }
  return <div className={styles.workbenchForceGuideStep3Wrap}>
    <div
      className={styles.tipDom}
      style={{
        left: position.left,
        top: position.top,
        borderRadius: '6px',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <img className={styles.topDomImage} src={src} />
      </div>
      <div
        className={styles.tip}
        style={{
          left: `${(position.width - 364) / 2}px`
        }}
      >
        <div className={styles.forceGuidePanelClose} onClick={onClose}>
          <Icon type="m-guanbi" />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>常用功能和好用的工具集合</div>
          <div className={styles.footer}>
            <span style={{ marginRight: '16px' }}>(2/2)</span>
            <Button onClick={onNext}>完成</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
}

const EndModal = ({ onClose }) => {
  return <div
    className={styles['mn-css-modal']}
    style={{
      width: '480px',
      height: '284px',
    }}
  >
    <Icon type="m-guanbi" className={styles['mn-css-modal-close']} onClick={onClose} />
    <div className={styles.endModalContent}>
      <div className={styles.endModalTitle}>好多客户都说它好用，重磅推荐</div>
      <div className={styles.card}>
        <img className={styles.logo} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/%E6%94%B6%E8%97%8Flogo.png" />
        <div className={styles.cardInfo}>
          <div className={styles.cardInfoTitle}>美念采集工具</div>
          <div className={styles.cardInfoLine2}>支持在站外对任何图片采集到美念、图搜同款</div>
          <div className={styles.cardInfoLine3}>
            <span style={{ marginRight: '8px' }}>市场评分：5分</span>
            <img className={styles.cardInfoLine3Collect} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/%E6%94%B6%E8%97%8F%402x.png" />
            <img className={styles.cardInfoLine3Collect} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/%E6%94%B6%E8%97%8F%402x.png" />
            <img className={styles.cardInfoLine3Collect} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/%E6%94%B6%E8%97%8F%402x.png" />
            <img className={styles.cardInfoLine3Collect} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/%E6%94%B6%E8%97%8F%402x.png" />
            <img className={styles.cardInfoLine3Collect} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/%E6%94%B6%E8%97%8F%402x.png" />
          </div>
        </div>
      </div>
      <div style={{ textAlign: 'center', marginTop: '32px' }}>
        <Button
          type="primary"
          style={{ width: '200px' }}
          onClick={() => {
            window.open('https://meinian.zhiyitech.cn/tool')
            onClose()
          }}
        >立即安装</Button>
      </div>
    </div>
  </div>
}
